import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useCommerce } from './CommerceContext';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { products } = useCommerce();
  const [cart, setCart] = useState(() => {
    try { const saved=JSON.parse(localStorage.getItem('nrnd-cart') || '[]'); return Array.isArray(saved)?saved:[]; } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  useEffect(() => localStorage.setItem('nrnd-cart', JSON.stringify(cart)), [cart]);
  const add = (productId,variant={}) => { const product=products.find(item=>item.id===productId);if(!product)return;const size=variant.size||product.sizes?.[0]||'',color=variant.color||product.colors?.[0]||'',key=`${productId}:${size}:${color}`;setCart(current=>{const found=current.find(item=>item.key===key);return found?current.map(item=>item.key===key?{...item,qty:item.qty+1}:item):[...current,{key,productId,size,color,qty:1}]});setOpen(true); };
  const change = (key, delta) => setCart(current => current.map(item=>item.key===key?{...item,qty:item.qty+delta}:item).filter(item=>item.qty>0));
  const clear = () => setCart([]);
  const items = useMemo(() => cart.map(line => ({ ...products.find(p=>p.id===line.productId), ...line })).filter(x=>x.id), [cart,products]);
  const count = items.reduce((sum,item)=>sum+item.qty,0);
  const total = items.reduce((sum,item)=>sum+item.price*item.qty,0);
  return <CartContext.Provider value={{cart,items,count,total,open,setOpen,add,change,clear}}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
